import { FunctionComponent } from 'react';
import { HeaderSearchBarViewModel } from '../../models/HeaderSearchBarViewModel';
import SearchBox from '../atoms/form/SearchBox';

const FullTextSearchForm: FunctionComponent<HeaderSearchBarViewModel> = (props: HeaderSearchBarViewModel) => (
  <SearchBox {...props} id="fulltextsearchform" collapsible={false} />
);

export default FullTextSearchForm;
